import {useEffect} from "react";
import {RowDescriptorRenderProps} from "@/components/extension/settings/types";
import {Checkbox} from "@mui/material";
import {formCheckboxMargin} from "@/constants";
import {useStructureConfig} from "@/context/StructureConfigProvider";

export const VoicemailToEmailEnabledWidget = (props: RowDescriptorRenderProps<"voicemailToEmailEnabled">) => {
    const {disabled, field, form, externalDisabled, value, updateValue} = props;

    const {isEnabledService} = useStructureConfig();

    useEffect(() => {
        if (form.values.notificationEmail.length === 0 && value) {
            updateValue(false);
        }
    }, [form.values.notificationEmail.length, updateValue, value]);

    if (!isEnabledService("voicemail")) return null;

    return (
        <Checkbox
            disabled={disabled || form.values.notificationEmail.length === 0 || externalDisabled}
            id={field}
            checked={form.values[field]}
            onChange={(event) => form.updateValues({[field]: event.target.checked})}
            color="primary"
            style={{marginLeft: formCheckboxMargin}}
        />
    );
};
